import { combineReducers } from 'redux'
import { createGenericTrendsReducer } from 'reducers/data/genericReducer'
import { getTimeframeLastMonth } from 'helpers/dateTimeHelpers'
import { SET_CREDIT_TOTALS, SET_CREDIT_ACCOUNTS } from 'actions/creditActions'
import { Reducer } from 'interfaces/index'
import { CREDIT_DISCARD_TRIGGERS, needDiscardData } from 'helpers/discardTriggerHelpers'
import { CreditDataState, MemberCreditAccountsByMonth, MemberCreditTotalsByMonth } from 'interfaces/credit'

const creditDiscardTrigger = needDiscardData(CREDIT_DISCARD_TRIGGERS)

const TOTALS_DEFAULT_STATE: MemberCreditTotalsByMonth = {}
const totalsReducer: Reducer<MemberCreditTotalsByMonth> = (state = TOTALS_DEFAULT_STATE, action) => {
  if (creditDiscardTrigger(action)) {
    return state
  }

  if (action.type === SET_CREDIT_TOTALS) {
    const { data, timeframe } = action.payload
    const lastMonth = getTimeframeLastMonth(timeframe)

    return {
      ...state,
      [lastMonth]: data,
    }
  }

  return state
}

const ACCOUNTS_DEFAULT_STATE: MemberCreditAccountsByMonth = {}
const accountsReducer: Reducer<MemberCreditAccountsByMonth> = (state = ACCOUNTS_DEFAULT_STATE, action) => {
  if (creditDiscardTrigger(action)) {
    return state
  }

  if (action.type === SET_CREDIT_ACCOUNTS) {
    const { data, timeframe } = action.payload
    const lastMonth = getTimeframeLastMonth(timeframe)

    return {
      ...state,
      [lastMonth]: data,
    }
  }

  return state
}

export default combineReducers<CreditDataState>({
  accounts: accountsReducer,
  totals: totalsReducer,
  trends: createGenericTrendsReducer('creditscore'),
})
